import { STARTER } from 'self-service-api/constants/ProductLevels';
import { getIsUngatedForSeats } from './gatingUtils';
import { getProductLevelForCoreSeats } from './productConfigUtils';
import { getProductsFromProductInventory, hasProductLineInBundledProductInventory } from './productInventoryUtils';
import { getProductForSkuId, getSkuIdIsOrHasHub, isQuantifiableHub } from './productsUtils';
export const getShowPricePerMonthPerSeat = (state, {
  skuId
}) => {
  const isUngatedForSeats = getIsUngatedForSeats(state);
  const product = getProductForSkuId(state, {
    skuId
  });
  const isQuantifiable = isQuantifiableHub(state, {
    skuId
  });
  const coreSeatTierOwned = getProductLevelForCoreSeats(state, {
    productConfigurations: []
  });
  const productsFromProductInventory = getProductsFromProductInventory(state);
  const ownsProductLineViaProducts = product.productLine ? productsFromProductInventory.some(prod => prod && prod.productLine === product.productLine && prod.productLevel) : false;
  const ownsProductLineViaBundle = product && hasProductLineInBundledProductInventory(state, {
    productLine: product.productLine
  });
  const ownsProductLine = ownsProductLineViaProducts || ownsProductLineViaBundle;
  return isUngatedForSeats && (isQuantifiable || !isQuantifiable && (
  // If the highest owned tier is free or starter, show the Starter price in "/mo/seat" format on ALL hubs
  coreSeatTierOwned === STARTER && product.productLevel === STARTER ||
  // If looking at merch card of a hub OWNED, show Starter price in "/mo/seat" format
  ownsProductLine && product.productLevel === STARTER));
};
export const getShowIncludedSeatsDisplay = (state, {
  skuId
}) => {
  return getSkuIdIsOrHasHub(state, {
    skuId
  });
};